export default __webpack_public_path__ + "static/media/submit-failed.a892af9c.svg";